function initializeScript() {
    waitForElement("#oke-loyalty-redeem .c-customisableRedemptionModule", (targetNode) => {
        initObserver(targetNode);
        moveSection();
    });
}

// Initial page load
window.addEventListener("load", initializeScript);

// Browser back/forward cache restore
window.addEventListener("pageshow", function (event) {
    // event.persisted === true means restored from bfcache
    if (event.persisted) {
        console.log("Page restored from back-forward cache");
        initializeScript();
    }
});

function waitForElement(selector, callback, timeout = 10000) {
    const interval = 300;
    let elapsed = 0;

    const timer = setInterval(() => {
        const el = document.querySelector(selector);

        if (el) {
            clearInterval(timer);
            callback(el);
        }

        elapsed += interval;

        if (elapsed >= timeout) {
            clearInterval(timer);
            console.warn(selector + " not found within timeout");
        }
    }, interval);
}

function initObserver(targetNode) {
    // Prevent duplicate observers
    if (targetNode.dataset.observerAttached) return;

    targetNode.dataset.observerAttached = "true";

    const observer = new MutationObserver(() => {
        moveSection();
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true
    });
}

function moveSection() {
    const targetContainer = document.querySelector('#oke-loyalty-redeem .c-customisableRedemptionModule');
    const targetElement = document.querySelector('#redeem-section');

    if (!targetElement || !targetContainer) return;

    if (targetElement && targetContainer) {
    targetContainer.before(targetElement);
    }

}